import React from "react";
import Modal from "./Modal";
import Button from "../Button";
import Icon from "../Icon";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const InvitedAccepted = ({ setShowAcceptedModal, showAcceptedModal }) => {
  const { providerContract } = useSelector((store) => store.user);
  const userString = localStorage.getItem("inviteData");
  let inviteData = userString ? JSON.parse(userString) : {};
  const navigate = useNavigate();
  return (
    <Modal
      hideClose={true}
      isHeader={true}
      title={
        providerContract?.id ? "Review Contract" : "Add Services & Pricing"
      }
      show={showAcceptedModal}
      containerClassName={`success-modal`}
    >
      <span>
        <Icon id={"checkSuccess"} height={"64"} width={"64"} />
      </span>
      <h4 className="mt-4 tx-c font-bold">Invite Accepted Successfully</h4>
      <p className="mt-2 co-gray tx-c ">
        {providerContract?.id
          ? `Review contracts prepared by  ${inviteData?.data?.resellerName} .`
          : `Add your services & pricing while ${
              inviteData?.data?.resellerName
                ? inviteData?.data?.resellerName
                : "resellers"
            } prepares their offer for you.`}
      </p>

      <Button
        variant="primary"
        type="submit"
        className="mt-4"
        block
        size={"md"}
        onClick={() => {
          inviteData.invitedAccepted = true;
          localStorage.setItem("inviteData", JSON.stringify(inviteData));
          navigate("/review/service");
        }}
      >
        {providerContract?.id ? "Review Contracts" : "Add Services & Pricing"}
      </Button>
    </Modal>
  );
};

export default InvitedAccepted;
